import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Form, Modal, OverlayTrigger, Tooltip, Accordion, Card, Tabs, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Moment from "react-moment";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Lottie from "lottie-react";
import { IoMdPlay } from "react-icons/io";
import { truncateRaceType, formatDateStandard } from "../../service/stringUtils";
import { MdKeyboardArrowRight, MdKeyboardArrowDown, MdHeight } from "react-icons/md";
import { AiFillCaretDown } from "react-icons/ai";
import { IoCaretUpSharp } from "react-icons/io5";
import { BsFillFilterCircleFill } from "react-icons/bs";
import ScrollContainer from "react-indiana-drag-scroll";
import { FcDown, FcUp } from "react-icons/fc";

import DefaultimgJockey from "../../assets/Frame.png";


// import img1 from "../../assets/trophy.png"; 
// import img from "../../assets/trophy-silver.png";
import arrow1 from "../../assets/image 13 (Traced).png";
import Animate from "../../assets/loader.json";

import JockeyDetail from "../Modal/JockeyModal";
import OwnerDetail from "../Modal/OwnerModal";
import RaceModal from "../Modal/RaceModal";
import TrainerDetail from "../Modal/TrainerModal";
import VideoFrame from "../Modal/VideoFrame";
import NoHistory from "../Reuseable/NoHistory";
import PleaseWait from "../Reuseable/PleaseWait";
import downloadIcon from "../../assets/download (1).png"
import sortIcon from "../../assets/sort.png"
import UpIcon from "../../assets/arrow-up.png"
import DownIcon from "../../assets/arrow-down.png"
import { FaStar } from "react-icons/fa";
import greenmeter from "../../assets/green-speed.png";
import redmeter from "../../assets/red-speed.png"

// Isolated Style Import
// import "./RaceDetailCardNew.css"; 
import { fetchHorseHistoryForRace } from "../../redux/getReducer/getHorseHistoryForRace";
import { getRaceStatusColor } from "../../service/raceStatusColor";


const CardData = ({ showSortPanel, setShowSortPanel }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const id = location.search.slice(1);
  const { data: singlerace, status } = useSelector((state) => state.singlerace);
  const cookiedata = Cookies.get("i18next");
  const token = Cookies.get("token");

  // States for Sort and Print (Moved to parent, receiving as props)
  const [SortedData, setSortData] = useState([]);
  const [sortCriteria, setSortCriteria] = useState({ type: 'horseNo', direction: 'asc' });

  // Modal States — Horse now navigates to page, so no modal state needed for it
  const [showJockey, setShowJockey] = useState(false);
  const [modaldataJockey, setmodaldataJockey] = useState();
  const handleCloseJockey = () => setShowJockey(false);
  const handleShowJockey = (data) => {
    const id = data?.JockeyOnRaceData1?._id || data?._id || data;
    if (id) navigate("/jockey-detail?" + id);
  };

  const [showOwner, setShowOwner] = useState(false);
  const [modaldataOwner, setmodaldataOwner] = useState();
  const handleCloseOwner = () => setShowOwner(false);
  const handleShowOwner = (data) => { const id = data?.OwnerOnRaceData1?._id; if (id) navigate("/owner-detail?" + id); };

  const [showTrainer, setShowTrainer] = useState(false);
  const [modaldataTrainer, setmodaldataTrainer] = useState();
  const handleCloseTrainer = () => setShowTrainer(false);
  const handleShowTrainer = (data) => { const id = data?.TrainerOnRaceData1?._id || data?._id || data; if (id) navigate("/trainer-detail?" + id); };

  const [showRace, setShowRace] = useState(false);
  const [modaldataRace, setmodaldataRace] = useState();
  const handleCloseRace = () => setShowRace(false);
  const handleShowRace = (data) => { const id = data?._id || data; if (id) navigate("/race-detail?" + id); };

  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => { setmodaldatas(data); await setShows(true); };

  // Logic Helpers
  const getColor = (g, b, gr) => {
    if (g > 0) return "#FFB800";
    if (b > 0) return "#078BE6";
    if (gr > 0) return "#979695";
    return null;
  };

  // Client: no 1st / 2nd / 3rd in the last year means no flag at all.
  const renderFlag = (label, g, b, gr) => {
    const color = getColor(g, b, gr);
    return color ? <span style={{ backgroundColor: color }}>{t(label)}</span> : null;
  };

  function compareNumbers(a, b) {
    const previousRating = a == null ? null : Number(a);
    const currentRating = b == null ? null : Number(b);
    if (previousRating == null || currentRating == null) return <p className="updownicon">-</p>;
    if (previousRating === currentRating) return <p className="updownicon">-</p>;
    return previousRating < currentRating ? <p className="updownicon"><img src={UpIcon} style={{ height: "25px", width: "25px" }} alt="Up Icon" /></p> : <p className="updownicon"><img src={DownIcon} style={{ height: "25px", width: "25px" }} alt="Down Icon" /></p>;
  }

  const calculateAge = (dob) => moment().diff(dob, "years");
  function extractValues(value) { if (!value) return "0"; return value.replace(/[^0-9-]/g, "").slice(0, 5); }
  function distanceLabel(distance, rank) {
    const d = parseFloat(distance);
    if (d.toFixed(2) > 25) return "Dist";
    if (d.toFixed(2) == 0.05 && rank < 80) return "SHd";
    if (d.toFixed(2) == 0.1 && rank < 80) return "Hd";
    if (d.toFixed(2) == 0.25 && rank < 80) return "Nk";
    if (d.toFixed(2) == 0.01 && rank < 80) return "Ns";
    if (d.toFixed(2) == 0.0 && rank < 80) return rank === 1 ? 0 : "Dh";
    return distance;
  }

  const toTitleCase = (str) => {
    if (!str) return "-";
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // Owner / trainer change lines, same logic as the horse history (HorseModal): a line is shown when the
  // owner or trainer of the newer run (or of today's race card) differs from the older run's.
  const recordName = (record) => {
    if (!record) return "";
    return cookiedata === "en"
      ? toTitleCase(record.NameEn || record.ShortNameEn || "")
      : record.NameAr || record.ShortNameAr || "";
  };
  const isDifferent = (a, b) => {
    const nameA = recordName(a);
    const nameB = recordName(b);
    if (!nameA || !nameB) return false;
    return (a?._id && b?._id && a._id !== b._id) || nameA.toLowerCase() !== nameB.toLowerCase();
  };
  const changeLines = (olderRun, newer) => {
    const lines = [];
    if (isDifferent(olderRun?.OwnerIdData, newer.owner)) {
      lines.push({
        kind: "owner",
        text: cookiedata === "en"
          ? <>Owner changed from <strong>{recordName(olderRun.OwnerIdData)}</strong> to <strong>{recordName(newer.owner)}</strong></>
          : <>تغير المالك من <strong>{recordName(olderRun.OwnerIdData)}</strong> إلى <strong>{recordName(newer.owner)}</strong></>,
      });
    }
    if (isDifferent(olderRun?.TrainerOnRaceDataResult, newer.trainer)) {
      lines.push({
        kind: "trainer",
        text: cookiedata === "en"
          ? <>Trainer changed from <strong>{recordName(olderRun.TrainerOnRaceDataResult)}</strong> to <strong>{recordName(newer.trainer)}</strong></>
          : <>تغير المدرب من <strong>{recordName(olderRun.TrainerOnRaceDataResult)}</strong> إلى <strong>{recordName(newer.trainer)}</strong></>,
      });
    }
    return lines;
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined) return "0";
    return new Intl.NumberFormat("en-US").format(num);
  };

  const formatSpeed = (val) => {
    if (val === null || val === undefined || val === "" || val === "N/A") return "N/A";
    const num = parseFloat(val);
    return isNaN(num) ? "N/A" : num.toFixed(2);
  };

  // --- SORTING LOGIC ---
  const handleSorting = (type, direction) => {
    setSortCriteria({ type, direction });
    let baseData = datafilter.length > 0 ? [...datafilter] : [];
    let sorted = baseData.sort((a, b) => {
      let valA, valB;

      switch (type) {
        case 'horseNo':
          valA = a.HorseNo || 0;
          valB = b.HorseNo || 0;
          return direction === 'asc' ? valA - valB : valB - valA;
        case 'gateNo':
          valA = a.GateNo || 0;
          valB = b.GateNo || 0;
          return direction === 'asc' ? valA - valB : valB - valA;
        case 'rating':
          valA = a.Rating || 0;
          valB = b.Rating || 0;
          return direction === 'asc' ? valA - valB : valB - valA;
        case 'weight':
          valA = parseFloat(a.JockeyRaceWeight) || 0;
          valB = parseFloat(b.JockeyRaceWeight) || 0;
          return direction === 'asc' ? valA - valB : valB - valA;
        case 'horseName':
          valA = (cookiedata === 'en' ? a.HorseModelIdData1?.NameEn : a.HorseModelIdData1?.NameAr) || "";
          valB = (cookiedata === 'en' ? b.HorseModelIdData1?.NameEn : b.HorseModelIdData1?.NameAr) || "";
          return direction === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        case 'jockey':
          valA = (cookiedata === 'en' ? a.JockeyOnRaceData1?.NameEn : a.JockeyOnRaceData1?.NameAr) || "";
          valB = (cookiedata === 'en' ? b.JockeyOnRaceData1?.NameEn : b.JockeyOnRaceData1?.NameAr) || "";
          return direction === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        case 'trainer':
          valA = (cookiedata === 'en' ? a.TrainerOnRaceData1?.NameEn : a.TrainerOnRaceData1?.NameAr) || "";
          valB = (cookiedata === 'en' ? b.TrainerOnRaceData1?.NameEn : b.TrainerOnRaceData1?.NameAr) || "";
          return direction === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        case 'owner':
          valA = (cookiedata === 'en' ? a.OwnerOnRaceData1?.NameEn : a.OwnerOnRaceData1?.NameAr) || "";
          valB = (cookiedata === 'en' ? b.OwnerOnRaceData1?.NameEn : b.OwnerOnRaceData1?.NameAr) || "";
          return direction === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        default:
          return 0;
      }
    });
    setSortData(sorted);
  };

  const datafilter = singlerace?.racehorses?.RacehorsesData || [];
  const displayList = SortedData.length > 0 ? SortedData : datafilter;
  const historyByKey = useSelector((state) => state.horseHistoryForRace?.byKey || {});

  const historyKey = (raceId, horseId) => `${raceId}:${horseId}`;

  const horseIdsInView = useMemo(() => {
    const ids = [];
    for (const item of displayList) {
      const horseId = item?.HorseModelIdData1?._id;
      if (horseId) ids.push(horseId);
    }
    return Array.from(new Set(ids));
  }, [displayList]);

  useEffect(() => {
    if (!id) return;
    if (!horseIdsInView.length) return;
    horseIdsInView.forEach((horseId) => {
      dispatch(fetchHorseHistoryForRace({ raceId: id, horseId }));
    });
  }, [horseIdsInView, id, dispatch]);

  return (
    <div className="new-card-tab-master-wrapper">

      {/* 2. HORIZONTAL SORT PANEL (Red Box UI) */}
      {showSortPanel && (
        <div className="new-horizontal-sort-panel">
          <div className="new-sort-grid">
            {[
              { label: "Horse No", type: "horseNo" },
              { label: "Gate No", type: "gateNo" },
              { label: "Horse Name", type: "horseName" },
              { label: "Jockey Name", type: "jockey" },
              { label: "Trainer Name", type: "trainer" },
              { label: "Owner Name", type: "owner" },
              { label: "Rating", type: "rating" },
              { label: "Jockey Weight", type: "weight" }
            ].map((s, i) => (
              <div key={i} className="new-sort-col">
                <label>{t(s.label)}:</label>
                <div className="new-sort-icons">
                  <IoCaretUpSharp
                    onClick={() => handleSorting(s.type, 'asc')}
                    style={{ color: sortCriteria.type === s.type && sortCriteria.direction === 'asc' ? '#000' : '#ccc', cursor: 'pointer' }}
                  />
                  <AiFillCaretDown
                    onClick={() => handleSorting(s.type, 'desc')}
                    style={{ color: sortCriteria.type === s.type && sortCriteria.direction === 'desc' ? '#000' : '#ccc', cursor: 'pointer' }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {status === "loading" ? (
        <div className="text-center py-5"><Lottie animationData={Animate} style={{ width: 150, margin: "auto" }} /></div>
      ) : (
        <div className="new-horse-list-container">
          {displayList.map((data, index) => {
            const rankValue = data.HorseModelIdData1?.UaeCareer?.find(c => c.FinalPositionDataHorse.Rank <= 3)?.FinalPositionDataHorse.Rank;
            const isRaceRed = getRaceStatusColor(singlerace?.racedetail?.RaceStatus, singlerace?.racedetail) === "#ef3a45";
            const cumulativeDistance = data.HorseModelIdData1?.UaeCareer?.[0]?.Distance;
            return (
              <div key={index} className="new-horse-entry-card">

                {/* NON-RUNNER WATERMARK */}
                {data.HorseRunningStatus === false && (
                  <div className="new-non-runner-overlay"><span>{t("NonRunner")}</span></div>
                )}

                {/* --- MIDDLE SECTION: THREE BOX GRID --- */}
                <div className="new-middle-info-grid">
                  {/* BOX 1: Identity & Rank (RESTORED logic) */}
                  <div className="new-grid-box new-identity-box">
                    <div className="new-identity-top">
                      <div className="new-star-rank">
                        <span className="new-star-icon">
                          {(rankValue == "1" || rankValue == "2" || rankValue == "3") && (
                            <FaStar
                              style={{
                                color:
                                  rankValue == "1"
                                    ? "#ffb12d"
                                    : rankValue == "2"
                                      ? "#9f9fa2"
                                      : "#8B4513" // brown
                              }}
                            />
                          )}
                        </span>
                        <span className="new-rank-text">
                          {singlerace?.racedetail?.ResultStatus === "Announced" && (
                            rankValue == "1" ? t("1st") :
                              rankValue == "2" ? t("2nd") :
                                rankValue == "3" ? t("3rd") : (index + 1)
                          )}
                        </span>
                        {isRaceRed && cumulativeDistance > 0 && (
                          <span className="new-rank-distance">{cumulativeDistance}</span>
                        )}
                      </div>

                      <div className="new-shirt-number-wrapper">
                        <div className="new-silk-shirt-container">
                          <img
                            src={data.CapColorData1?.OwnerSilkColor || DefaultimgJockey}
                            alt="Silk"
                            onError={(e) => { e.target.onerror = null; e.target.src = DefaultimgJockey; }}
                            className={`new-silk-img-fit ${!data.CapColorData1?.OwnerSilkColor ? 'is-placeholder' : ''}`}
                          />
                        </div>
                        <div className="new-number-info-container">
                          <span className="new-num-small-top">{data?.HorseModelIdData1 ? extractValues(data?.HorseModelIdData1?.HorseForm) : "0"}</span>
                          <span className="new-num-large-center">{data?.HorseNo}</span>
                          <span className="new-num-gate-bottom">({data?.GateNo === 100 ? "-" : data?.GateNo})</span>
                        </div>
                      </div>
                    </div>

                    <div className="new-mini-stats">
                      <div><b>{t("PM")}</b> <p>{formatNumber(data.HorseModelIdData1?.TotalPrizeWin)}</p></div>
                      <div><b>{t("BTO")}</b> <p>{formatNumber(data.HorseModelIdData1?.TotalBto)}</p></div>
                      <div><b>{t("SP")}</b> <p>{formatNumber(data.HorseModelIdData1?.PurchasePrice)}</p></div>
                    </div>
                  </div>

                  {/* BOX 2: Pedigree & Career RESTORED (Full Brackets) */}
                  <div className="new-grid-box new-pedigree-box">
                    <h3 className="new-horse-main-name" onClick={() => navigate(`/horse-detail?${data.HorseModelIdData1?._id}`)} style={{ cursor: 'pointer' }}>
                      {cookiedata === "en" ? toTitleCase(data.HorseModelIdData1?.NameEn) : data.HorseModelIdData1?.NameAr}
                      <small class="font-style">({cookiedata === "en" ? data.HorseModelIdData1?.NationalityData?.AbbrevEn : data.HorseModelIdData1?.NationalityData?.AbbrevAr}) {calculateAge(data.HorseModelIdData1?.DOB)} {t("yrs")}. {cookiedata === "en" ? data.HorseModelIdData1?.ColorIDData?.AbbrevEn : data.HorseModelIdData1?.ColorIDData?.AbbrevAr} {cookiedata === "en" ? data.HorseModelIdData1?.SexModelData?.AbbrevEn : data.HorseModelIdData1?.SexModelData?.AbbrevAr} <b>{data.HorseModelIdData1?.DaysGap && `(${data.HorseModelIdData1.DaysGap})`}</b></small>
                    </h3>

                    <div className="new-pedigree-grid">
                      <div className="pedigree-col">
                        {/* <span className="dam-title">Dam</span> */}
                        <span className="dam-name">
                          {cookiedata === "en"
                            ? toTitleCase(data.HorseModelIdData1?.DamData?.NameEn)
                            : data.HorseModelIdData1?.DamData?.NameAr}
                        </span>
                      </div>
                      <div className="pedigree-col">
                        {/* <span className="dam-title">Sire</span> */}
                        <span className="dam-name">
                          {cookiedata === "en"
                            ? toTitleCase(data.HorseModelIdData1?.SireData?.NameEn)
                            : data.HorseModelIdData1?.SireData?.NameAr}
                        </span>
                      </div>
                      <div className="pedigree-col">
                        {/* <span className="dam-title">GSire</span> */}
                        <span className="dam-name">
                          {cookiedata === "en" ? toTitleCase(data.HorseModelIdData1?.GSireData?.NameEn) : data.HorseModelIdData1?.GSireData?.NameAr}
                        </span>
                      </div>
                    </div>


                    <div className="new-contact-grid">
                      <div className="owner-name" onClick={() => handleShowOwner(data)}>
                        {cookiedata === "en" ? toTitleCase(data.OwnerOnRaceData1?.NameEn) : data.OwnerOnRaceData1?.NameAr}
                      </div>
                      <div className="owner-stats">
                        {data.OwnerOnRaceData1?.OwnerCount}&nbsp;({data.OwnerOnRaceData1?.OwnerFirstRanking}-{data.OwnerOnRaceData1?.OwnerSecondRanking}-{data.OwnerOnRaceData1?.OwnerThirdRanking})
                      </div>

                      <div className="trainer-name" onClick={() => handleShowTrainer(data)}>
                        {cookiedata === "en" ? toTitleCase(data.TrainerOnRaceData1?.NameEn) : data.TrainerOnRaceData1?.NameAr}
                      </div>
                      <div className="trainer-stats">
                        {data.TrainerOnRaceData1?.TrainerCount}&nbsp;({data.TrainerOnRaceData1?.TrainerFirstRanking}-{data.TrainerOnRaceData1?.TrainerSecondRanking}-{data.TrainerOnRaceData1?.TrainerThirdRanking})
                      </div>

                      <div className="breeder-name">
                        {cookiedata === "en" ? toTitleCase(data.HorseModelIdData1?.BreederData?.NameEn) : data.HorseModelIdData1?.BreederData?.NameAr}
                      </div>
                    </div>

                    <div className="new-career-stats-grid">
                      <span className="st-blue">{t("Lifetime")}: {data.HorseModelIdData1?.LifeTimeCount}({data.HorseModelIdData1?.LifeTimeFirstRanking}-{data.HorseModelIdData1?.LifeTimeSecondRanking}-{data.HorseModelIdData1?.LifeTimeThirdRanking})</span>
                      <span className="st-blue">{t("UAE")}: {data.HorseModelIdData1?.UaeCareerCount}({data.HorseModelIdData1?.UaeFirstRanking}-{data.HorseModelIdData1?.UaeSecondRanking}-{data.HorseModelIdData1?.UaeThirdRanking})</span>
                      <span className="st-red">{t("Dist")}: {data.HorseModelIdData1?.DistanceCount}({data.HorseModelIdData1?.DistanceFirstRanking}-{data.HorseModelIdData1?.DistanceSecondRanking}-{data.HorseModelIdData1?.DistanceThirdRanking})</span>
                      <span className="st-green">{t("Turf")}: {data.HorseModelIdData1?.TurfCount}({data.HorseModelIdData1?.TurfFirstRanking}-{data.HorseModelIdData1?.TurfSecondRanking}-{data.HorseModelIdData1?.TurfThirdRanking})</span>
                      <span className="st-brown">{t("Dirt")}: {data.HorseModelIdData1?.DirtCount}({data.HorseModelIdData1?.DirtFirstRanking}-{data.HorseModelIdData1?.DirtSecondRanking}-{data.HorseModelIdData1?.DirtThirdRanking})</span>
                      <span className="st-gray">{t("AW")}: {data.HorseModelIdData1?.AllWeatherCount}({data.HorseModelIdData1?.AllWeatherFirstRanking}-{data.HorseModelIdData1?.AllWeatherSecondRanking}-{data.HorseModelIdData1?.AllWeatherThirdRanking})</span>
                    </div>
                  </div>

                  {/* BOX 3: Jockey RESTORED (Full Brackets) */}
                  <div className="new-grid-box new-jockey-box">
                    <p className="new-equip-text">
                      {data.EquipmentData1?.NameEn === "No Equipment" ? "" : (cookiedata === "en" ? data.EquipmentData1?.NameEn : data.EquipmentData1?.NameAr)} <small className="font-normal">{t("OR")}: {data.Rating || "-"}</small>
                    </p>
                    <div className="new-jockey-flex">
                      {data.JockeyOnRaceData1?.image ?
                        <div className="owner-new-img-box">
                          <img src={data.JockeyOnRaceData1?.image} alt="Jockey" />
                        </div>
                        :
                        <div className="owner-new-img-box" style={{ padding: "10px" }}>
                          <img src={DefaultimgJockey} alt="Jockey" />
                        </div>}
                      <div className="new-jockey-name-wrap">

                        <h4 onClick={() => handleShowJockey(data)}>
                          {cookiedata === "en" ? toTitleCase(data.JockeyOnRaceData1?.NameEn) : data.JockeyOnRaceData1?.NameAr}
                          <small>{data.JockeyRaceWeight}{t("kg")}</small>
                        </h4>
                        <div className="line-change">
                          <p className="new-stats-inline">
                            {data.JockeyOnRaceData1?.JockeyCount}({data.JockeyOnRaceData1?.JockeyFirstRanking}-{data.JockeyOnRaceData1?.JockeySecondRanking}-{data.JockeyOnRaceData1?.JockeyThirdRanking || '0'})
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="new-indicator-row">
                      <div className="indicator-chips">
                        {renderFlag("C", data.HorseModelIdData1?.CourseGold, data.HorseModelIdData1?.CourseBlue, data.HorseModelIdData1?.CourseGrey)}
                        {renderFlag("D", data.HorseModelIdData1?.DistanceGold, data.HorseModelIdData1?.DistanceBlue, data.HorseModelIdData1?.DistanceGrey)}
                        {renderFlag("CL", data.HorseModelIdData1?.RaceTypeGold, data.HorseModelIdData1?.RaceTypeBlue, data.HorseModelIdData1?.RaceTypeGrey)}
                        <span className="new-rating-arrow">
                          {data.HorseModelIdData1
                            ? compareNumbers(data.HorseModelIdData1.RatingPrevious, data.Rating)
                            : <></>}
                        </span>
                      </div>
                    </div>

                    {/* Speedometer Section */}
                    <div className="new-speed-wrapper">
                      <div className="speed-item">
                        <img src={greenmeter} alt="Green Speed" className="speed-img" />
                        <p className="speed-text">{t("SPS")}: <span className="val-green">
                          {formatSpeed(historyByKey?.[historyKey(id, data?.HorseModelIdData1?._id)]?.turfSpeed ?? data?.GreenSpeed ?? data?.HorseModelIdData1?.GreenSpeed ?? data?.HorseModelIdData1?.SpeedGreen)}
                        </span></p>
                      </div>
                      <div className="speed-item">
                        <img src={redmeter} alt="Red Speed" className="speed-img" />
                        <p className="speed-text">{t("SPS")}: <span className="val-red">
                          {formatSpeed(historyByKey?.[historyKey(id, data?.HorseModelIdData1?._id)]?.dirtSpeed ?? data?.RedSpeed ?? data?.HorseModelIdData1?.RedSpeed ?? data?.HorseModelIdData1?.SpeedRed)}
                        </span></p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* --- BOTTOM SECTION: HISTORY GRID (16 COLUMNS) --- */}
                <div className="new-bottom-history-section">
                  <div className="new-history-grid-header">
                    <div>{window.textTransform(t("Date"))}</div>
                    <div>{window.textTransform(t("Crs"))}</div>
                    <div>{window.textTransform(t("Dist"))}</div>
                    {/* <div>{window.textTransform(t("TC"))}</div> */}
                    <div>{window.textTransform(t("RT"))}</div>
                    {/* <div>{window.textTransform(t("Dts"))}</div> */}
                    <div>{window.textTransform(t("Time"))}</div>
                    <div>{window.textTransform(t("Jockey"))}</div>
                    <div>{window.textTransform(t("Wgt"))}</div>
                    {/* Speed sits next to this horse's own weight, so it reads as this horse's speed. */}
                    <div>{window.textTransform(t("Speed"))}</div>
                    <div>{window.textTransform(t("FP"))}</div>
                    <div>{window.textTransform(t("Len"))}</div>
                    {/* <div>{window.textTransform(t("RN"))}</div> */}
                    <div>{window.textTransform(t("BtBy"))}</div>
                    <div>{window.textTransform(t("W Kgs"))}</div>
                    <div>{window.textTransform(t("Draw"))}</div>
                    <div>{window.textTransform(t("OR"))}</div>
                    <div></div>
                  </div>
                  <div className="new-history-grid-body">
                    {(historyByKey?.[historyKey(id, data?.HorseModelIdData1?._id)]?.list || []).slice(0, 4).map((h, i, runs) => {
                      // Above the latest run: today's card vs that run; above an older run: the next run vs it.
                      const newer = i === 0
                        ? { owner: data?.OwnerOnRaceData1, trainer: data?.TrainerOnRaceData1 }
                        : { owner: runs[i - 1]?.OwnerIdData, trainer: runs[i - 1]?.TrainerOnRaceDataResult };
                      const changes = changeLines(h, newer);
                      const groundEn = h.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                      const groundAr = h.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameAr || h.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                      const ground = cookiedata === "en" ? groundEn : groundAr;
                      const rowColor = groundEn === "Turf" ? "rgb(203 237 186)" : groundEn === "Dirt" ? "rgb(227 212 202)" : "#949494";
                      return (
                        <Fragment key={i}>
                        {changes.map((c) => (
                          <div key={c.kind} className={`new-horse-modal-change-row new-horse-modal-change-pill-${c.kind}`}>
                            <span>{c.text}</span>
                          </div>
                        ))}
                        <div className="new-history-row" style={{ backgroundColor: rowColor, color: '#0b0b0b !important' }}>
                          <div onClick={() => {
                            handleShowRace(h.RaceID);
                            navigate(`/race-detail?${h.RaceID}`);
                          }} className="new-link-white">{formatDateStandard(h.RaceResultData?.Day)}</div>

                          <div>{cookiedata === "en" ? (h.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceCourseData?.AbbrevEn || "-") : (h.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceCourseData?.TrackNameAr || "-")}({ground?.charAt(0)})</div>
                          <div>{h.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.TrackLength || "-"}</div>
                          {/* <div>{h.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackConditionData?.NameEn || "-"}</div> */}
                          <div className="new-truncate">{toTitleCase(cookiedata === "en" ? truncateRaceType(h.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceTypeModelData?.NameEn) : h.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceTypeModelData?.NameAr)}</div>
                          <div>{h.RaceTime && h.RaceTime !== "-" ? h.RaceTime : ((h.RaceResultData?.StartTime || h.RaceResultData?.Day) ? moment(h.RaceResultData.StartTime || h.RaceResultData.Day).format("hh:mm A") : "-")}</div>
                          <div onClick={() => {
                            const id = h.JockeyOnRaceDataResult?._id;
                            if (id) navigate(`/jockey-detail?${id}`);
                          }} className="new-jockey-link new-truncate">
                            {cookiedata === "en" ? window.textTransform(h.JockeyOnRaceDataResult?.ShortNameEn || "-") : (h.JockeyOnRaceDataResult?.ShortNameAr || "-")}
                          </div>
                          <div>{h.RaceResultData?.RacehorsesData?.[0]?.JockeyRaceWeight || 0}</div>
                          <div>{formatSpeed(h.Speed)}</div>
                          <div>{cookiedata === "en" ? (h.FinalPositionDataHorse?.NameEn || "-") : (h.FinalPositionDataHorse?.NameAr || "-")}</div>
                          <div>{distanceLabel(h.Distance, h.FinalPositionDataHorse?.Rank)}</div>
                          {/* <div>{h.Runners || 0}</div> */}
                          {(() => {
                            const rank = h.FinalPositionDataHorse?.Rank;
                            const targetHorse = rank === 1
                              ? (h.RunnerUpData || h.BeatenByData || null)
                              : (h.WinnerData || h.BeatenByData || null);
                            const targetName = targetHorse
                              ? (cookiedata === "en" ? toTitleCase(targetHorse.NameEn || "") : (targetHorse.NameAr || targetHorse.NameEn || "-"))
                              : (cookiedata === "en"
                                  ? toTitleCase(h.HorseIDData?.HorseBeatenByEnglishName || "")
                                  : (h.HorseIDData?.HorseBeatenByArabicName || h.HorseIDData?.HorseBeatenByEnglishName || "-"));
                            const targetId = targetHorse?._id || h.BeatenByData?._id;
                            const targetWeight = targetHorse?.WinningHorseJockeyWeight ?? h.BeatenByData?.WinningHorseJockeyWeight ?? h.HorseIDData?.BeatenByJockeyWeight ?? 0;

                            return (
                              <>
                                <div
                                  className={`new-truncate ${targetId ? "new-clickable-white" : ""}`}
                                  title={targetName || ""}
                                  onClick={() => targetId && navigate(`/horse-detail?${targetId}`)}
                                  style={{ cursor: targetId ? "pointer" : "default" }}
                                >
                                  {targetName || "-"}
                                </div>
                                <div>{targetWeight}</div>
                              </>
                            );
                          })()}
                          <div>{h.RaceResultData?.RacehorsesData?.[0]?.GateNo || "-"}</div>
                          <div>{h.Rating || 0}</div>
                          <div onClick={() => handleShows(h.VideoLink)} className="new-mini-play-white" ><IoMdPlay /></div>
                        </div>
                        </Fragment>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Modals */}
      <Modal show={showJockey} onHide={handleCloseJockey} size="lg" centered><Modal.Body><JockeyDetail data={modaldataJockey} /></Modal.Body></Modal>
      <Modal show={showOwner} onHide={handleCloseOwner} size="lg" centered><Modal.Body><OwnerDetail data={modaldataOwner} /></Modal.Body></Modal>
      <Modal show={showTrainer} onHide={handleCloseTrainer} size="lg" centered><Modal.Body><TrainerDetail data={modaldataTrainer} /></Modal.Body></Modal>
      <Modal show={showRace} onHide={handleCloseRace} size="lg" centered><Modal.Body><RaceModal id={modaldataRace} /></Modal.Body></Modal>
      <Modal show={shows} onHide={handleCloses} size="lg" centered><Modal.Body><VideoFrame data={modaldatas} /></Modal.Body></Modal>
    </div>
  );
};
export default CardData;